<div class="account-body accountbg">
  <div class="container">
    <div class="row vh-100 d-flex justify-content-center">
      <div class="col-10 align-self-center">
        <div class="row">
          <div class="col-lg-5 mx-auto">
            <div class="card">
              <div class="card-body p-0">
                <div class="text-center p-3">
                  <h4 class="mt-3" style="color: steelblue;">Reset Your Password</h4>
                  <p class="text-muted  mb-0">Please enter your new password below, and confirm new password.</p>
                </div>
              </div>
              <div class="card-body">
                @if (error) {
                  <div class="form-group alert alert-danger alert-block">
                    <h4 class="alert-heading mt-0">Failed!</h4>
                    {{error}}
                  </div>
                }
                <form
                  [formGroup]="resetPasswordForm"
                  class="form-horizontal auth-form"
                  novalidate
                  id="resetPasswordForm"
                  name="resetPasswordForm"
                  autocomplete="off">
                  <div class="form-group mb-2">
                    <label class="form-label" for="username">Email</label>
                    <div class="input-group">
                      <input
                        type="email"
                        class="form-control"
                        name="email"
                        formControlName="email"
                        autocomplete="username"
                        required
                        email
                        trim
                        [(ngModel)]="formData.email"
                        [ngClass]="{'is-invalid': email && email.touched && email.invalid}"
                        (change)="onEmailChangedDebounce()">
                        @if (email.errors?.['required']) {
                          <div class="invalid-feedback">Email is required.</div>
                        }
                      </div>
                    </div>

                    @if (formData.email) {
                      <div class="form-group mb-2">
                        <label class="form-label" for="userCompanyGuid">Company</label>
                        <select class="form-select" name="userCompanyGuid" id="userCompanyGuid" formControlName="userCompanyGuid" [(ngModel)]="formData.userCompanyGuid" (ngModelChange)="onCompanyChanged()">
                          <option [ngValue]="null">--Select One--</option>
                          @for (companies of availableCompanies | groupBy: 'companyGuid'; track companies.key) {
                            <optgroup label="{{companies.value[0].companyName}}">
                              @for (company of companies.value; track company.userCompanyGuid; let i = $index) {
                                <option value="{{company.userCompanyGuid}}">
                                    {{company.userType}} {{company.externalCompanyId ? (" - " + company.externalCompanyName ) : ""}}
                                </option>
                              }
                            </optgroup>
                          }
                        </select>
                      </div>
                    }

                    @if (formData.userCompanyGuid) {
                      <div class="form-group mb-2">
                        <label class="form-label" for="password">Password</label>
                        <div class="input-group">
                          <input
                            type="password"
                            class="form-control"
                            name="password"
                            formControlName="password"
                            autocomplete="new-password"
                            required
                            [(ngModel)]="formData.password"
                            [ngClass]="{'is-invalid' : password && password.touched && password.invalid}">
                            @if (password.errors?.['required']) {
                              <div class="invalid-feedback">Password is required.</div>
                            }
                            @if (password.errors?.['minlength']) {
                              <div class="invalid-feedback">Password must be at least {{passwordPolicy?.minimumPasswordLength || 8}} characters long.<br/></div>
                            }
                            @if (password.errors?.['uppercase']) {
                              <div class="invalid-feedback">Password must contain an uppercase character.<br/></div>
                            }
                            @if (password.errors?.['lowercase']) {
                              <div class="invalid-feedback">Password must contain a lowercase character.<br/></div>
                            }
                            @if (password.errors?.['requiresDigit']) {
                              <div class="invalid-feedback">Password must contain at least one digit.<br/></div>
                            }
                            @if (password.errors?.['requiresNonAplhaNumeric']) {
                              <div class="invalid-feedback">Password must contain non-alphanumeric character.<br/></div>
                            }
                          </div>
                        </div>
                        <div class="form-group mb-2">
                          <label class="form-label" for="confirmPassword">Confirm Password</label>
                          <div class="input-group">
                            <input
                              type="password"
                              class="form-control"
                              name="confirmPassword"
                              formControlName="confirmPassword"
                              autocomplete="new-password"
                              required
                              [(ngModel)]="formData.confirmPassword"
                              [ngClass]="{'is-invalid' : confirmPassword && (confirmPassword.touched && confirmPassword.invalid) || resetPasswordForm.hasError('stringDoesntMatch')}">
                              @if (confirmPassword.errors?.['required']) {
                                <div class="invalid-feedback">Confirm password is required.</div>
                              }
                              @if (resetPasswordForm.hasError('stringDoesntMatch')) {
                                <div class="invalid-feedback">Confirm password doesn't match password.<br/></div>
                              }
                            </div>
                          </div>
                          <div class="form-group mb-0 row">
                            <div class="col-12 mt-2">
                              <button class="btn btn-primary w-100" type="button" (click)="resetPassword()">
                                @if (resettingPassword) {
                                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                }
                                Reset Password
                              </button>
                            </div>
                          </div>
                        }

                        @if (resetDone) {
                          <div class="form-group mt-2 mb-0 alert alert-success alert-block">
                            <h4 class="alert-heading mt-0">Success!</h4>
                            Password changed successfully!
                            <br />
                            <a [routerLink]="['/login']">Click here to login</a>
                          </div>
                        }
                      </form>
                      <p class="text-muted text-center mb-0 mt-3">Already have an account?
                        <a [routerLink]="['/login']" class="text-primary ms-2">Log in</a>
                      </p>
                      <p class="text-muted text-center mb-0">Don't have an account?
                        <a href="https://www.lodasoft.com/#contact-us" class="text-primary ms-2">Request a Demo</a>
                      </p>
                      <!--end form-->
                    </div>
                    <div class="card-body bg-light-alt text-center login-footer">
                      <span class="text-muted d-none d-sm-inline-block">Lodasoft © {{currentYear}}
                        <script>
                          document.write(new Date().getFullYear())
                        </script>
                      </span>
                    </div>
                  </div>
                  <!--end card-->
                </div>
                <!--end col-->
              </div>
              <!--end row-->
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
        <!--end container-->
      </div>
